import React from 'react';
import PropTypes from 'prop-types';
import * as Router from 'react-router-dom';

const NavLink = props => (
  <li className="header-nav__menu-item">
    <Router.NavLink className="header-nav__menu-link" {...props} />
  </li>
);

NavLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default NavLink;
